app.directive('ckeditorPlaceholder', [function(){
    return {
        restrict: 'A',
        replace: false,
        require: ['?ckeditor'],
        transclude: false,
        scope: {
            'ckeditorPlaceholder':'@',
            'ngModel': '='
        },
        link: function(scope, element, attrs, ctrls){
            var ckeditor = ctrls[0];
            var spanPlaceholder = $("<span>").addClass('cke-placeholder').html(scope.ckeditorPlaceholder);
            var $ckeditor = null;
            ckeditor.ready().then(function(){
                $ckeditor = $(ckeditor.instance.container.$);
                $ckeditor.find('.cke_contents').append(spanPlaceholder);
                ckeditor.instance.on('blur', show);
                ckeditor.instance.on('key', show);
                ckeditor.instance.on('focus', show);
                ckeditor.instance.on('click', show);
                show();
            });

            function show(){
                if($ckeditor.hasClass('cke_focus') || ckeditor.instance.getData() !== "" || (scope.ngModel != "" && scope.ngModel != undefined)){
                    spanPlaceholder.hide();
                }else{
                    spanPlaceholder.show();
                }
            }

            //CkEditor PlaceHolder overlapped the text
            scope.$watch('ngModel', function () {
                if (scope.ngModel != undefined && $ckeditor != null) {
                    show();
                }                               
            });
        },
    };
}]);